import { takeLatest } from "redux-saga/effects";
import { put } from "redux-saga/effects";
import axiosApi from "../../utils/axios";
import { customFormData } from "../../utils/customFormData";
import { addNotification } from "../actions/notifierActions";
import {
  RequestWatermarkUpload,
  SuccessWatermarkUpload,
  FailureWatermarkUpload,
  RequestManualWatermarkDecode,
  SuccessManualWatermarkDecode,
  FailureManualWatermarkDecode,
} from "../actions/watermarkDecoderActions";

export function* watermarkUpload({ payload }) {
  const { file, onSuccess } = payload;
  try {
    const formData = customFormData({});
    formData.append("file", file);
    const response = yield axiosApi.post("/api/watermark/upload", formData, { timeout: 120000 });
    yield put(SuccessWatermarkUpload(response?.data));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(FailureWatermarkUpload());
    yield put(
      addNotification({
        message: error?.response?.data?.error || "Upload failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* manualWatermarkDecode({ payload }) {
  const { watermarkString } = payload;
  try {
    const response = yield axiosApi.post("/api/watermark/manual_decode", {
      watermark_string: watermarkString,
    });
    yield put(SuccessManualWatermarkDecode(response?.data?.result));
  } catch (error) {
    yield put(FailureManualWatermarkDecode());
    yield put(
      addNotification({
        message: error?.response?.data?.error || "Manual decode error",
        options: { variant: "error" },
      }),
    );
  }
}

const watermarkDecoderSagas = [
  takeLatest(RequestWatermarkUpload, watermarkUpload),
  takeLatest(RequestManualWatermarkDecode, manualWatermarkDecode),
];

export default watermarkDecoderSagas;
